export const ALGOLIA_CHALLENGES_INDEX_BASE = 'courses[challenges]';
export const ALGOLIA_PODCASTS_INDEX_BASE = 'courses[podcasts]';
export const ALGOLIA_PREMIUM_TRAININGS_INDEX_BASE = 'courses[premium_trainings]';
export const ALGOLIA_WORKSHOPS_INDEX_BASE = 'courses[workshops]';

export const ALGOLIA_BREATHWORK_INDEX_BASE = 'pranayamas';
export const ALGOLIA_CLASSES_INDEX_BASE = 'classes';
export const ALGOLIA_MEDITATIONS_INDEX_BASE = 'meditations';
export const ALGOLIA_ARTICLES_INDEX_BASE = 'articles';
export const ALGOLIA_TEACHERS_INDEX_BASE = 'teachers';
export const ALGOLIA_POSES_INDEX_BASE = 'poses';
export const ALGOLIA_SERIES_INDEX_BASE = 'series';
export const ALGOLIA_SITE_WIDE_BASE = 'site-wide-search';

export type IndexBase =
  | typeof ALGOLIA_CHALLENGES_INDEX_BASE
  | typeof ALGOLIA_PODCASTS_INDEX_BASE
  | typeof ALGOLIA_PREMIUM_TRAININGS_INDEX_BASE
  | typeof ALGOLIA_WORKSHOPS_INDEX_BASE
  | typeof ALGOLIA_BREATHWORK_INDEX_BASE
  | typeof ALGOLIA_CLASSES_INDEX_BASE
  | typeof ALGOLIA_MEDITATIONS_INDEX_BASE
  | typeof ALGOLIA_ARTICLES_INDEX_BASE
  | typeof ALGOLIA_TEACHERS_INDEX_BASE
  | typeof ALGOLIA_POSES_INDEX_BASE
  | typeof ALGOLIA_SERIES_INDEX_BASE
  | typeof ALGOLIA_SITE_WIDE_BASE;
